import {AssignedSocialHelpResponsePayload} from '../../../models/api';

export default {
  recipientCategories: [
    {
      code: '02010003',
      name: 'Инвалид III группы',
    },
    {
      code: '10000011',
      name: 'Пенсионеры, получающие страховую пенсию по старости',
    },
    {
      code: '10000013',
      name: 'Лица, постоянно проживающие на территории субъекта Российской Федерации и состоящие в браке 50, 60, 70 и 75 лет',
    },
    {
      code: '11050001',
      name: 'Лица, имеющие удостоверение «Ветеран труда»',
    },
  ],
  socialSupportMeasures: [
    {
      id: 1010101000000,
      ssmCode: '0537',
      period: 'Ежемесячно',
      assignedSSM: {
        volume: 766,
        dateSoc: '01.02.2020',
        startDate: '18.02.2020',
        endDate: '31.12.2020',
      },
      name: 'Компенсационная выплата в связи с расходами по оплате общей площади занимаемых жилых помещений (в коммунальных помещениях - жилой площади), найма, содержания и ремонта жилых помещений (для собственников жилых помещений и членов жилищно-строительных (жилищных) кооперативов - содержания и ремонта объектов общего пользования в многоквартирных жилых домах) (Комп.выплата в связи с расходами по оплате жилых помещений)',
      ssmForm: 'Денежная',
      regulatoryLevel: '',
      regulatoryLevelName: 'Федеральный уровень',
      assigned: false,
    },
    {
      id: 1010102000000,
      ssmCode: '0538',
      name: 'Компенсационная выплата в связи с расходами по оплате коммунальных услуг независимо от вида жилищного фонда (Комп.выплата в связи с расходами по оплате коммунальных услуг)',
      ssmForm: '01',
      regulatoryLevel: '',
      regulatoryLevelName: '',
      period: '',
      assigned: false,
      assignedSSM: null,
    },
    {
      id: 1020600000000,
      ssmCode: '0448',
      name: 'Ежемесячная денежная выплата (Ежем.пос.на пользование услугами телефонной связи)',
      ssmForm: '01',
      regulatoryLevel: '02',
      regulatoryLevelName: 'Уровень субъектов РФ',
      period: '',
      assigned: false,
      assignedSSM: null,
    },
    {
      id: 1020700000000,
      ssmCode: '0448',
      name: 'Ежемесячная денежная выплата (Ежем.пос.на пользование услугами радиовещания)',
      ssmForm: '01',
      regulatoryLevel: '02',
      regulatoryLevelName: 'Уровень субъектов РФ',
      period: '',
      assigned: false,
      assignedSSM: null,
    },
    {
      id: 1020800000000,
      ssmCode: '0448',
      name: 'Ежемесячная денежная выплата (Ежем.пос.на пользование услугами телевещания)',
      ssmForm: '01',
      regulatoryLevel: '02',
      regulatoryLevelName: 'Уровень субъектов РФ',
      period: '',
      assigned: false,
      assignedSSM: null,
    },
    {
      id: 1020900000000,
      ssmCode: '0448',
      name: 'Ежемесячная денежная выплата (Ежемесячное пособие на проезд)',
      ssmForm: '01',
      regulatoryLevel: '02',
      regulatoryLevelName: 'Уровень субъектов РФ',
      period: '',
      assigned: false,
      assignedSSM: null,
    },
    {
      id: 1030606000000,
      ssmCode: '0536',
      name: 'Компенсация в размере 50 процентов от уплаченной страховой премии по договору обязательного страхования гражданской ответственности владельцев транспортных средств (Компенсация страховой премии по договору обязательного страхования',
      ssmForm: '01',
      regulatoryLevel: '',
      regulatoryLevelName: '',
      period: '',
      assigned: false,
      assignedSSM: null,
    },
    {
      id: 1030640000000,
      ssmCode: '0452',
      name: 'Единовременная материальная помощь отдельным категориям граждан, осуществившим подключение жилых домов к природному газу (Частичная компенсация затрат на подключение жилых помещений к газовым сетям гражданам, которым установлена досрочная страховая пенсия по старости, страховая пенсия по инвалидности или социальная пенсия по инвалидности)',
      ssmForm: '01',
      regulatoryLevel: '02',
      regulatoryLevelName: 'Уровень субъектов РФ',
      period: '',
      assigned: false,
      assignedSSM: null,
    },
    {
      id: 1030641000000,
      ssmCode: '0452',
      name: 'Единовременная материальная помощь отдельным категориям граждан, осуществившим подключение жилых домов к природному газу (Частичное освобождение от затрат на подключение жилых помещений к газовым сетям гражданам, которым установлена досрочная страховая пенсия по старости, страховая пенсия по инвалидности или социальная пенсия по инвалидности)',
      ssmForm: '01',
      regulatoryLevel: '02',
      regulatoryLevelName: 'Уровень субъектов РФ',
      period: '',
      assigned: false,
      assignedSSM: null,
    },
    {
      id: 1030905000000,
      ssmCode: '0475',
      name: 'Единовременная выплата (пособие) /вознаграждение (Единовременное пособие для лиц, награжденных знаком отличия Свердловской области «Совет да любовь»)',
      ssmForm: '01',
      regulatoryLevel: '02',
      regulatoryLevelName: 'Уровень субъектов РФ',
      period: '',
      assigned: false,
      assignedSSM: {
        volume: 5000,
        measure: 'руб',
        dateSoc: '16.08.2012',
        startDate: '01.09.2012',
        endDate: '30.09.2012',
        sign: true,
      },
    },
    {
      id: 1031001000000,
      ssmCode: '0408',
      name: 'Ежегодная денежная выплата: в т.ч. целевая (на приобретение новогодних подарков) (Ежегодное пособие на проезд)',
      ssmForm: '01',
      regulatoryLevel: '02',
      regulatoryLevelName: 'Уровень субъектов РФ',
      period: '',
      assigned: false,
      assignedSSM: {
        volume: 825,
        measure: 'руб',
        dateSoc: '31.10.2013',
        startDate: '01.01.2014',
        endDate: '',
        sign: false,
      },
    },
    {
      id: 2050400000000,
      ssmCode: '0757',
      name: 'Полное или частичное освобождение от оплаты путевок на санаторно-курортное лечение: Частичное освобождение от оплаты путевок на санаторно-курортное лечение (Бесплатная путевка на санаторно-курортное лечение)',
      ssmForm: '01',
      regulatoryLevel: '',
      regulatoryLevelName: '',
      period: '',
      assigned: false,
      assignedSSM: null,
    },
    {
      id: 2111300000000,
      ssmCode: '0779',
      name: 'Полное или частичное освобождение (скидка) от оплаты проезда железнодорожным, водным, воздушным или междугородним автомобильным транспортом (Б/пл проезд автоб.тран. в меж/город.сообщ.по СО)',
      ssmForm: '01',
      regulatoryLevel: '02',
      regulatoryLevelName: 'Уровень субъектов РФ',
      period: '',
      assigned: false,
      assignedSSM: {
        volume: 135,
        measure: 'руб',
        dateSoc: '06.10.2019',
        startDate: '06.01.2019',
        endDate: '',
        sign: false,
      },
    },
  ],
} as AssignedSocialHelpResponsePayload;
